import React, { useMemo } from 'react';
import { RiPlayFill } from 'react-icons/ri';
import { v4 as uuidv4 } from 'uuid';

import Mode from './Mode';

import { getModeId } from '@/utils/CommandUtils';

const Panel = ({ data: robots }) => {
  const modeId = useMemo(() => {
    return getModeId(robots[0].model.vehicle, 'AUTO');
  }, [robots]);

  return <Mode data={robots} modeId={modeId} desc="Executes pre-planned mission automatically" />;
};

const Command = {};
Command.id = uuidv4();
Command.name = 'Auto';
Command.displayMode = 'sidebar';
Command.singleRobotOnly = false;
Command.commanderOnly = true;
Command.Icon = RiPlayFill;
Command.Panel = Panel;

export default Command;
